export const TILE_SIZES = {
  small: { width: 25 },
  medium: { width: 30 },
  large: { width: 35 },
  "x-large": { width: 50 },
};

export enum TileColor {
  GRAY = "gray",
  RED = "red",
  BLUE = "blue",
  ORANGE = "orange",
  GREEN = "green",
  PURPLE = "purple",
  YELLOW = "yellow",
}

export const TILE_COLORS = {
  [TileColor.GRAY]: { backgroundColor: "#ddd" },
  [TileColor.RED]: { backgroundColor: "#f31" },
  [TileColor.BLUE]: { backgroundColor: "#9de" },
  [TileColor.ORANGE]: { backgroundColor: "#f80" },
  [TileColor.GREEN]: { backgroundColor: "#6f8" },
  [TileColor.PURPLE]: { backgroundColor: "#d6f" },
  [TileColor.YELLOW]: { backgroundColor: "#fd5" },
};
